import { NxIconRegistry } from "@allianz/ng-aquila/icon";
import { AsyncPipe } from "@angular/common";
import { Component } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { AuthSessionFacade } from "@services/auth-session/auth-session.facade";
import { HttpHelperService } from "@services/http-helper.service";
import { ScrollTopComponent } from "@shared/components/scroll-top/scroll-top.component";

import { environment } from "../environments/environment";
import { FooterComponent } from "./components/footer/footer.component";
import { HeaderComponent } from "./components/header/header.component";
import { LoadingComponent } from "./shared/components/global/loading/loading.component";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
  host: {
    "[class.login-route]": "isLoginRoute",
  },
  imports: [
    RouterOutlet,
    FooterComponent,
    HeaderComponent,
    AsyncPipe,
    LoadingComponent,
    ScrollTopComponent,
  ],
})
export class AppComponent {
  protected user$ = this.authSessionFacade.user$;
  private readonly authRoutePrefixes = [
    "/login",
    "/secret-answer",
    "/first-time-login",
    "/reset-password",
    "/password-expired",
  ] as const;
  private readonly footerHelpdeskExcludedRoutePrefixes = [
    "/summary",
    "/reports",
    "/enquiry",
    "/ci",
  ] as const;

  private readonly legacyNdbxIconNames = [
    "arrow-upload",
    "bars",
    "download",
    "export-and-share",
    "filter",
    "product-board-paper-note",
    "product-paper-document",
    "product-to-do-list",
    "search",
    "user-o",
    "xls",
  ] as const;

  protected get isLoginRoute(): boolean {
    return this.isAuthRoute(this.router.url);
  }

  protected get isLoginPage(): boolean {
    return this.isAuthRoute(this.router.url);
  }

  protected get showFooterHelpdesk(): boolean {
    return !this.footerHelpdeskExcludedRoutePrefixes.some((prefix) =>
      this.isCurrentRouteAtOrUnder(prefix),
    );
  }

  constructor(
    private readonly translate: TranslateService,
    private readonly httpHelperService: HttpHelperService,
    private readonly authSessionFacade: AuthSessionFacade,
    private readonly iconRegistry: NxIconRegistry,
    private readonly router: Router,
  ) {
    translate.setDefaultLang("en");
    this.httpHelperService.setEnv(environment.apiUrl);
    this.registerLegacyNdbxIcons();
  }

  private registerLegacyNdbxIcons(): void {
    const legacyFontName = "legacy-ndbx-font";
    this.iconRegistry.registerFont(legacyFontName, "ndbx-icon", "nx-icon--");

    for (const iconName of this.legacyNdbxIconNames) {
      this.iconRegistry.addFontIcon(iconName, undefined, legacyFontName);
    }
  }

  private isAuthRoute(url: string): boolean {
    return this.authRoutePrefixes.some((prefix) => url.startsWith(prefix));
  }

  private isCurrentRouteAtOrUnder(prefix: string): boolean {
    const currentPath = this.router.url.split(/[?#]/, 1)[0];

    return currentPath === prefix || currentPath.startsWith(`${prefix}/`);
  }
}
//check
